import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getTransactionsColumns } from './columns';

export const useTableColumns = () => {
  const { t } = useTranslation(['common', 'accountBilling']);

  const columns = useMemo(() => {
    const commonColumns = getTransactionsColumns(t);

    return commonColumns;
  }, [t]);

  return { columns };
};
